import { useGestorSesion } from '../../hooks/useGestorSesion';
import { useRastreadorActividad } from '../../hooks/useRastreadorActividad';
import { ModalAdvertenciaSesion } from './ModalAdvertenciaSesion';

/**
 * GestorSesion - Wrapper para Session Management
 * 
 * Este componente debe estar DENTRO de ToastProvider porque
 * los hooks usan useToast()
 */
export const GestorSesion = () => {
    const {
        showWarning,
        minutesRemaining,
        dismissWarning,
        handleRenewSession,
        handleLogoutNow,
        isRefreshing
    } = useGestorSesion();

    useRastreadorActividad();

    return (
        <ModalAdvertenciaSesion
            open={showWarning}
            minutesRemaining={minutesRemaining || 0}
            onClose={dismissWarning}
            onRenewSession={handleRenewSession}
            onLogoutNow={handleLogoutNow}
            isRefreshing={isRefreshing}
        />
    );
};
